import { __assign } from 'tslib';
import format from '../../node_modules/date-fns/esm/format/index.js';

var useDatePickerHeading = function (_a) {
    var date = _a.date, locale = _a.locale;
    return {
        props: {
            children: format(date, "MMMM y", __assign({}, (locale && { locale: locale }))),
        },
    };
};

export { useDatePickerHeading };
//# sourceMappingURL=useDatePickerHeading.js.map
